import React from 'react';

import { Paper, Text } from '@mantine/core';
import InvoiceStatusBadge from 'components/invoices/InvoiceStatusBadge';
import { useLocalization } from 'context/localization-context';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { Invoice } from 'types';

interface InvoiceCardProps {
  invoice: Invoice;
}

const InvoiceCard = ({ invoice }: InvoiceCardProps): JSX.Element => {
  const { formatCurrency, dateFormat } = useLocalization();

  return (
    <Paper
      component={Link}
      to={`/invoices/${invoice.invoiceId}`}
      radius='lg'
      p='lg'
      shadow='xs'
      mt='xs'
      sx={{ position: 'relative' }}
    >
      <InvoiceStatusBadge
        status={invoice.status}
        size='md'
        fullWidth={false}
        sx={{ position: 'absolute', top: -8, right: 8 }}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto min-content',
          gap: '8px',
          whiteSpace: 'nowrap',
        }}
      >
        <Text weight={600} size='lg' truncate>
          {invoice.invoiceItems.map(invoiceItem => invoiceItem.productName).join(', ')}
        </Text>
        <Text weight={600} size='lg' align='end'>
          {formatCurrency(invoice.total / 100)}
        </Text>

        <Text size='sm' weight={500} color='dimmed' italic>
          {`Due date: ${dayjs(invoice.dueDate).format(dateFormat)}`}
        </Text>
        <Text size='sm' weight={500} color='dimmed'>
          {'Payment date: ' + (invoice.paymentDate ? dayjs(invoice.paymentDate).format(dateFormat) : '-')}
        </Text>
      </div>
    </Paper>
  );
};

export default InvoiceCard;
